import React, { useState } from 'react';
import { Input } from 'components/Inputs';
import PropTypes from 'prop-types';
import history from 'routing/history';
import { ReactComponent as SearchIcon } from 'products/nomad_insurance/assets/img/icons/menu/search.svg';
import { SearchInputContainer } from './styled';
import { Header } from '../../styled';

const FaqSearchBar = ({ onSearch, product }) => {
  const [value, setValue] = useState('');

  const onSubmit = (e) => {
    e.preventDefault();
    onSearch();
    history.push(`/${product}/faq?searchStr=${value}`);
  };
  return (
    <>
      <Header>Have questions?</Header>
      <form onSubmit={onSubmit}>
        <SearchInputContainer>
          <SearchIcon onClick={onSubmit} />
          <Input
            type="text"
            placeholder="Search FAQs"
            value={value}
            onChange={(e) => setValue(e.target.value)}
          />
        </SearchInputContainer>
      </form>{' '}
    </>
  );
};

FaqSearchBar.propTypes = {
  onSearch: PropTypes.func.isRequired,
  product: PropTypes.string.isRequired
};

export default FaqSearchBar;
